import React from 'react';
import { contribution } from '../data/portfolio';
import { Label } from './Label';
export function BoardroomContribution() {
  return <section id="contribution" aria-labelledby="contribution-heading" className="scroll-mt-20 bg-ink px-6 py-24 md:px-10 md:py-32" data-id="element-49" data-mp="2hs99vx8bo0py">
      <div className="mx-auto w-full max-w-edge" data-id="element-50" data-mp="2ri2nt4vxsrxd">
        <Label data-id="element-51" data-mp="2rivmrjonmd4y">Boardroom Contribution</Label>

        <h2 id="contribution-heading" className="mt-10 max-w-4xl font-display text-3xl font-normal leading-[1.14] text-paper md:text-[3.5rem]" data-id="element-52" data-mp="2vjnvmbtm6g0p">
          What Nigel brings into the boardroom
        </h2>

        <dl className="mt-20 border-t border-white/15" data-id="element-53" data-mp="35in5tyu12jpt">
          {contribution.map(group => <div key={group.theme} className="grid gap-4 border-b border-white/10 py-9 lg:grid-cols-12 lg:items-baseline lg:gap-12" data-id="element-54" data-mp="3af3wp0sm3c6l">
              <dt className="font-display text-3xl font-normal leading-none text-paper lg:col-span-4 md:text-[2.5rem]" data-id="element-55" data-mp="1g1m42zdcnp4p">
                {group.theme}
              </dt>
              <dd className="lg:col-span-8" data-id="element-56" data-mp="2m7rm5zfj6szf">
                <ul className="flex flex-wrap items-baseline gap-x-8 gap-y-3" data-id="element-57" data-mp="2m6zpsme40r83">
                  {group.items.map(item => <li key={item} className="text-base uppercase tracking-[0.16em] text-fog md:text-[1.05rem]" data-id="element-58" data-mp="2h6ls9ya4wzob">
                      {item}
                    </li>)}
                </ul>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}